<div class="ribbon-group">
  <div class="ribbon-group-content tx-tab-find-and-replace">
    <div class="d-flex align-items-center gap-1">
      <button (click)="openReplaceModal()">
        <i class="bi bi-binoculars"></i>
        Replace
      </button>
      <button (click)="openFindModal()">
        <i class="bi bi-binoculars"></i>
        Find
      </button>
    </div>
  </div>
  <div class="ribbon-group-label-container">
    <p class="ribbon-group-label">Replace</p>
  </div>
</div>
